import React from "react";
import { Link, Match } from "@reach/router";
import { Disclosure } from "@headlessui/react";
import classNames from "classnames";
import { ChevronRightIcon } from "@heroicons/react/solid";
import { CurrentUser } from "../../lib/network/auth/Auth";

const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      return {
        className: classNames(
          props.className,
          isCurrent
            ? "bg-white text-black"
            : "text-gray-300 hover:bg-gray-700 hover:text-white"
        ),
      };
    }}
  ></Link>
);

const SideNav = () => {
  return (
    <nav className="mt-5 flex-1 space-y-1 px-2">
      {CurrentUser.sideBarNavigation()?.map((item) =>
        !item.children ? (
          <div key={item.name}>
            <NavLink
              to={item.href}
              className="group flex w-full items-center rounded-md py-2 pl-2 text-sm font-medium"
            >
              <item.icon
                className="mr-3 h-6 w-6 flex-shrink-0"
                aria-hidden="true"
              />

              {item.name}
            </NavLink>
          </div>
        ) : (
          <Match key={item.name} path={item.subMenuPath}>
            {(props) => {
              return (
                <Disclosure
                  as="div"
                  key={item.name}
                  className="space-y-1"
                  defaultOpen={props.match}
                >
                  {({ open }) => (
                    <>
                      <Disclosure.Button
                        className={classNames(
                          open || props.match
                            ? "bg-gray-200 text-black"
                            : "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "group flex w-full items-center rounded-md py-2 pl-2 pr-1 text-left text-sm font-medium focus:outline-none "
                        )}
                      >
                        <item.icon
                          className={classNames(
                            open || props.match
                              ? "text-gray-800 "
                              : "text-gray-400 group-hover:text-gray-300",
                            "mr-3 h-6 w-6 flex-shrink-0"
                          )}
                          aria-hidden="true"
                        />
                        <span className="flex-1">{item.name}</span>
                        <ChevronRightIcon
                          className={classNames(
                            open || props.match
                              ? "rotate-90 text-gray-600 group-hover:text-gray-900"
                              : "text-gray-300 group-hover:text-gray-400",
                            "ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out"
                          )}
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="relative space-y-2">
                        {(open || props.match) && (
                          <div className="absolute top-0 left-5 -ml-px h-full w-0.5 bg-gray-300" />
                        )}
                        {item.children.map((subItem) => (
                          <NavLink
                            key={subItem.name}
                            to={subItem.href}
                            className="group top relative ml-10 flex items-center rounded-md py-2 pl-2 pr-2 text-sm font-medium"
                          >
                            <subItem.icon
                              className="mr-3 h-6 w-6 flex-shrink-0"
                              aria-hidden="true"
                            />
                            {subItem.name}
                          </NavLink>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              );
            }}
          </Match>
        )
      )}
    </nav>
  );
};

export default SideNav;
